import { RQ } from 'utils';

export default {
  getInfo: async function () {
    let self = this;
    let d = await RQ.mall.get('/api/h5/enterprise/property/getPrivacyPolicy', {
      enterpriseNo: self.enterprise,
      isPlatform: self.isPlatform
    }, {
      enterprise: '00'
    });
    if (d && d.code == 0) {
      console.log(d, d.data, d.data.enterpriseNo);
      self.info = d.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/privacy/action.js